"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardType = void 0;
var BoardType;
(function (BoardType) {
    BoardType[BoardType["UNKNOWN"] = 0] = "UNKNOWN";
    BoardType[BoardType["SLIMEVR_LEGACY"] = 1] = "SLIMEVR_LEGACY";
    BoardType[BoardType["SLIMEVR_DEV"] = 2] = "SLIMEVR_DEV";
    BoardType[BoardType["NODEMCU"] = 3] = "NODEMCU";
    BoardType[BoardType["CUSTOM"] = 4] = "CUSTOM";
    BoardType[BoardType["WROOM32"] = 5] = "WROOM32";
    BoardType[BoardType["WEMOSD1MINI"] = 6] = "WEMOSD1MINI";
    BoardType[BoardType["TTGO_TBASE"] = 7] = "TTGO_TBASE";
    BoardType[BoardType["ESP01"] = 8] = "ESP01";
    BoardType[BoardType["SLIMEVR"] = 9] = "SLIMEVR";
    BoardType[BoardType["LOLIN_C3_MINI"] = 10] = "LOLIN_C3_MINI";
    BoardType[BoardType["BEETLE32C3"] = 11] = "BEETLE32C3";
    BoardType[BoardType["ESP32C3DEVKITM1"] = 12] = "ESP32C3DEVKITM1";
    BoardType[BoardType["OWOTRACK"] = 13] = "OWOTRACK";
    BoardType[BoardType["WRANGLER"] = 14] = "WRANGLER";
    BoardType[BoardType["MOCOPI"] = 15] = "MOCOPI";
    BoardType[BoardType["WEMOSWROOM02"] = 16] = "WEMOSWROOM02";
    BoardType[BoardType["XIAO_ESP32C3"] = 17] = "XIAO_ESP32C3";
    BoardType[BoardType["HARITORA"] = 18] = "HARITORA";
    BoardType[BoardType["ESP32C6DEVKITC1"] = 19] = "ESP32C6DEVKITC1";
    BoardType[BoardType["GLOVE_IMU_SLIMEVR_DEV"] = 20] = "GLOVE_IMU_SLIMEVR_DEV";
    BoardType[BoardType["GESTURES"] = 21] = "GESTURES";
    BoardType[BoardType["SLIMEVR_V1_2"] = 22] = "SLIMEVR_V1_2";
    BoardType[BoardType["ESP32S3_SUPERMINI"] = 23] = "ESP32S3_SUPERMINI";
    BoardType[BoardType["GENERIC_NRF"] = 24] = "GENERIC_NRF";
    BoardType[BoardType["SLIMEVR_BUTTERFLY_DEV"] = 25] = "SLIMEVR_BUTTERFLY_DEV";
    BoardType[BoardType["SLIMEVR_BUTTERFLY"] = 26] = "SLIMEVR_BUTTERFLY";
    BoardType[BoardType["DEV_RESERVED"] = 250] = "DEV_RESERVED";
})(BoardType = exports.BoardType || (exports.BoardType = {}));
